import angular from 'angular';

import component from './fnb-reservations.component';

const FnbReservations = angular.module('control-room.fnb-reservations', []).component('crFnbReservations', component);

export default FnbReservations;
